import {
  ConfirmationSuspendDeactivateIcon,
  DeactivateIcon,
  SadSmileyFace,
} from "@/assets";
import { Button } from "@/components/ui/button";
import {
  DialogClose,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { ToastMessage, type } from "@/lib/toastr";
import { suspendTeamMember } from "@/services/Settings.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChevronLeft, ChevronRight, Loader2 } from "lucide-react";
import { useState } from "react";

const Deactivate = ({ name, id, handleDialogItemOpenChange }) => {
  const queryClient = useQueryClient();
  const [step, setStep] = useState(1);
  const mutation = useMutation({
    mutationFn: async (id) => await suspendTeamMember(id),
    mutationKey: ["suspendTeam"],
    onSuccess: (res) => {
      queryClient.clear();
      setStep(2);
      ToastMessage(type.SUCCESS, "Team member suspended successfully");
    },
    onError: (err) => {
      handleDialogItemOpenChange(false);
      setStep(1);
      ToastMessage(type.ERROR, err.response.data.message);
    },
  });
  return (
    <div className="flex flex-col items-center justify-center gap-10 p-8">
      <div className="flex flex-col gap-9">
        <DialogHeader className="flex flex-col items-center text-center ">
          {step == 1 ? (
            <DeactivateIcon />
          ) : (
            <ConfirmationSuspendDeactivateIcon />
          )}
          <div className="flex flex-col gap-2">
            <DialogTitle className="text-center text-error">
              {step == 1
                ? "Deactivate This Team Member?"
                : "Team Member Deactivated Successfully!"}
            </DialogTitle>
            <DialogDescription className="text-center">
              {step == 1
                ? "Are you sure you want to deactivate this member?"
                : `${name} was successfully deactivated from the Treasura platform`}
            </DialogDescription>
          </div>
        </DialogHeader>
        {step === 1 && (
          <div className="flex flex-col justify-around bg-off-white-1 gap-4 w-full rounded-[8px] py-5 px-4">
            <div className="flex items-center gap-1 ">
              <SadSmileyFace />
              <span className="text-sm text-gray">
                Deactivate this team member will cause;
              </span>
            </div>
            <ul className="gap-6 px-3 list-disc list-inside">
              <li className="text-xs text-gray-80">
                Member will be logged out from all active sessions.
              </li>
              <li className="text-xs text-gray-80 ">
                Member will not be able to log into Treasura,
              </li>
            </ul>
          </div>
        )}
      </div>
      <div className="flex flex-col items-center w-full ">
        {step == 1 ? (
          <>
            <Button
              type="submit"
              className="bg-error h-12 rounded-[10px] w-full"
              onClick={() => mutation.mutate(id)}
            >
              {mutation?.isPending && (
                <Loader2 className="text-white animate-spin" />
              )}
              Yes, I want to deactivate this member <ChevronRight />
            </Button>
            <DialogClose asChild>
              <Button type="button" variant="ghost">
                No, I want to cancel
              </Button>
            </DialogClose>
          </>
        ) : (
          <DialogClose asChild onClick={() => setStep(1)}>
            <ChevronLeft /> Back to dashboard
          </DialogClose>
        )}
      </div>
    </div>
  );
};

export default Deactivate;
